<template>
  <div>
    <v-container>
      <!-- <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div> -->
      <div class="mt-3">
        <div class="title mb-3">จำนวนการส่งขอประเมินจากลูกค้า</div>
        <v-card style="width: 300px">
          <div class="pa-3 text-xs-center">
            <v-progress-circular
              style="margin-top: 29.2px; margin-bottom: 17.52px; height: 48px"
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <h3 v-else>{{ (data && data.length ? data[0].total : 0) | numberFormat }}</h3>
          </div>
        </v-card>
        <!-- <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="data"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center pa-3">
                <div style="cursor: pointer" @click="showPayslipImage(props.item.image_url, 'url')">
                  <v-img
                    v-if="/(\.pdf$)/.test(props.item.image_url)"
                    width="140px"
                    src="/static/img/pdf-image-placeholder.94190da.png"
                  ></v-img>
                  <v-img v-else width="140px" :src="props.item.image_url"></v-img>
                </div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.status }}</div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.message ? props.item.message : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.transactionid ? props.item.transactionid : '-' }}</div>
              </td>

              <td class="text-xs-center pa-3">
                <div
                  v-if="props.item.payslip"
                  @click="showPayslipImage(props.item.payslip, 'base64')"
                >
                  <v-img width="140px" :src="props.item.payslip"></v-img>
                </div>
                <div v-else>-</div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}</div>
              </td>
            </tr>
          </template>
        </v-data-table> -->
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'ชื่อ', value: 'first_name', align: 'center', width: '1%' },
        { text: 'ประเภทรถ', value: 'type', align: 'center', width: '1%' },
        { text: 'สถานะ', value: 'status', align: 'center', width: '1%' },
        { text: 'ราคาเสนอ', value: 'quotation_amount', align: 'center', width: '1%' },
        { text: 'ราคาซื้อ', value: 'invoice_amount', align: 'center', width: '1%' },
        { text: 'วันที่ต้องการเช่า', value: 'start_date', align: 'center', width: '1%' },
        { text: 'วันที่ลงทะเบียน', value: 'start_date', align: 'center', width: '1%' },
        { text: 'ข้อมูลติดต่อ', value: 'contact', align: 'center', width: '1%' },
        { text: 'สถานที่', value: 'location', align: 'center', width: '1%' },
        { text: 'บริษัท', value: 'company', align: 'center', width: '1%' },
        { text: 'Supplier ที่ทำงาน', value: 'supplier', align: 'center', width: '1%' },
        { text: 'Remark', value: 'remark', align: 'center', width: '1%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
          // datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          // dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
        }
        this.loading = true
        api.ordersummarywithoutshippingdashboard(data, (err, response) => {
          this.loading = false
          this.data = response.data
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Dealer/ordersummarywithoutshipping.vue